import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=0a2f5304&"
import script from "./Tasks.vue?vue&type=script&lang=ts&"
export * from "./Tasks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports